let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fkutI")).then(() => parcelRequire('kQ8Dl'));